export default __webpack_public_path__ + "17ec0bc79493df511cc7deda271a42d5.svg";